class Status {
  name: string;
  id: string;
  color: string;

  constructor( name: string, id: string, color: string ) {
    this.name = name;
    this.id = id;
    this.color = color;
  }

  static allStates: Array<Status> = [
    new Status( 'Late', 'LATE', '#FF9944' ),
    new Status( 'Done', 'DONE', '#44BB44' ),
    new Status( 'Planned', 'COMING', '#60A0F2' ), //old : #5599EE
    new Status( 'Canceled', 'CANCELED', '#FF5555' ),
    new Status( 'Unplanned', 'UNPLANNED', '#FFAA00' ),
  ];

  static getStateByID( id: string ): Status | undefined {
    return this.allStates.find( state => {return state.id === id;} );
  }

  static statusToState( id: string ): string | undefined {
    return this.getStateByID( id )?.name;
  }

  static statusToColor( id: string ): string | undefined {
    return this.getStateByID( id )?.color;
  }
}

export default Status;